let initPending = false;

const dom = {
  $: (s, p = document) => p.querySelector(s),
  $$: (s, p = document) => p.querySelectorAll(s),
  parseJSON: (d, f = {}) => {
    try {
      return JSON.parse(d);
    } catch {
      return f;
    }
  }
};

const ui = {
  debounce(f, w) {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => f(...a), w);
    };
  },
  toggleLoading(s, show) {
    if (!s) return;
    let spinner = s.querySelector('.custom-loading-spinner') || (() => {
      const el = document.createElement('div');
      el.className = 'custom-loading-spinner';
      el.innerHTML = '<div class="custom-spinner-circle"></div>';
      s.appendChild(el);
      return el;
    })();
    Object.assign(s.style, show ? { opacity: '0.5', pointerEvents: 'none' } : { opacity: '', pointerEvents: '' });
    s.querySelectorAll(':scope > *:not(.custom-loading-spinner)').forEach(el => el.style.display = show ? 'none' : '');
    spinner.style.display = show ? 'flex' : 'none';
  }
};

const cart = {
  async refresh() {
    const drawer = dom.$('cart-drawer');
    if (!drawer) return;
    try {
      if (drawer.renderContents) {
        const [cart, sections] = await Promise.all([fetch('/cart.js'), fetch('/?sections=cart-drawer,cart-icon-bubble,cart-items')]);
        const [cartData, sectionsData] = await Promise.all([cart.json(), sections.json()]);
        drawer.renderContents({ ...cartData, original_total_price: cartData.original_total_price || cartData.total_price, sections: sectionsData });
      } else {
        const html = await (await fetch('/cart')).text();
        const newDrawer = (new DOMParser()).parseFromString(html, 'text/html').querySelector('cart-drawer');
        if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
      }
    } catch {
      try {
        const html = await (await fetch('/?section_id=cart-drawer')).text();
        const div = document.createElement('div');
        div.innerHTML = html;
        const newHTML = dom.$('#shopify-section-cart-drawer', div)?.innerHTML;
        if (newHTML) dom.$('#shopify-section-cart-drawer').innerHTML = newHTML;
      } catch {}
    }
    setTimeout(init, 100);
  },
  open() {
    const drawer = dom.$('cart-drawer');
    if (!drawer || drawer.hasAttribute('open') || drawer.classList.contains('is-open')) return;
    if (drawer.open) drawer.open(dom.$('[data-cart-toggle], #cart-icon-bubble'));
    else dom.$('.header__icon--cart, [data-cart-toggle]')?.click();
  }
};

const product = {
  async fetch(handle) {
    const fns = [window.fetchProductData, window.getProductData];
    for (const fn of fns) {
      if (fn && fn !== product.fetch) {
        if (fn === window.getProductData) return new Promise(r => fn(`/products/${handle}.js`, r));
        return await fn(handle);
      }
    }
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error('Fetch failed');
    return res.json();
  },
  findVariant(variants, color, size) {
    return variants.find(v => [v.option1, v.option2, v.option3].includes(color) && [v.option1, v.option2, v.option3].includes(size));
  }
};

const swatches = {
  cache: null,
  load() {
    if (this.cache) return this.cache;
    this.cache = window.patternTheme?.colorSwatches || {};
    if (!Object.keys(this.cache).length) {
      document.querySelectorAll('script[id^="ColorSwatches-"]').forEach(s => {
        try {
          Object.assign(this.cache, JSON.parse(s.textContent));
        } catch {}
      });
    }
    return this.cache;
  },
  apply() {
    const data = this.load();
    const type = window.variantColorTypeGlobal || 'image';
    const tmpl = window.variantColorTypeTemplate || 'global';
    document.querySelectorAll('.color-swatch-inline').forEach(el => {
      const name = el.dataset.color;
      if (!name) return;
      const info = data[name] || data[name.toLowerCase()] || data[name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()] || data[name.replace(/-/g, ' ')] || data[name.replace(/-/g, ' ').toLowerCase()];
      const useImage = info?.colorImage && (tmpl !== 'global' && el.closest('.template-swatches') ? window.variantColorTypeTemplate : type) === 'image';
      const bg = useImage ? `url("${info.colorImage}")` : info?.color || name;
      Object.assign(el.style, {
        background: bg,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      });
    });
  }
};

function init() {
  if (initPending) return;
  initPending = true;
  setTimeout(() => {
    const cards = dom.$$('product-card[data-handle]');
    if (!cards.length) {
      initPending = false;
      return;
    }
    cards.forEach(card => {
      if (card.dataset.pdpInitialized === 'true' || !dom.$('.pdp-card-bottom', card)) return;
      card.dataset.pdpInitialized = 'true';
      product.fetch(card.dataset.handle).then(data => {
        setupCard(card, data);
        swatches.apply();
        setupImages(card, data);
      }).catch(e => {
        console.error(e);
        card.dataset.pdpInitialized = 'false';
      }).finally(() => ui.toggleLoading(dom.$('.cart-drawer__collection-products'), false));
    });
    initPending = false;
  }, 50);
}
function scrollCartToBottom() {
  const drawer =
    document.querySelector("cart-drawer") ||
    document.querySelector("#CartDrawer");

  if (!drawer) return;

  const scroller =
    drawer.querySelector(".cart-scroller") ||
    drawer.querySelector(".drawer__inner") ||
    drawer.querySelector("[class*='scroll']");

  if (!scroller) return;

  requestAnimationFrame(() => {
    scroller.scrollTop = scroller.scrollHeight;
  });
}

function smartScrollIntoViewInDrawer(el) {
  if (!el) return;

  const drawer =
    document.querySelector("cart-drawer") ||
    document.querySelector("#CartDrawer");

  const scroller =
    drawer?.querySelector(".cart-scroller") ||
    drawer?.querySelector(".drawer__inner") ||
    drawer?.querySelector("[class*='scroll']");

  if (!scroller) return;

  requestAnimationFrame(() => {
    const elRect = el.getBoundingClientRect();
    const scrollerRect = scroller.getBoundingClientRect();

    if (elRect.bottom > scrollerRect.bottom) {
      scroller.scrollBy({
        top: elRect.bottom - scrollerRect.bottom,
        behavior: "smooth",
      });
    }

    if (elRect.top < scrollerRect.top) {
      scroller.scrollBy({
        top: elRect.top - scrollerRect.top,
        behavior: "smooth",
      });
    }
  });
}
// test
function setupCard(card, data) {
  const bottom = dom.$('.pdp-card-bottom', card);
  if (!bottom) return;
  dom.$('.pdp-selectors-container', bottom)?.remove();
  dom.$('.pdp-add-to-cart-btn', bottom)?.remove();
  card.dataset.productVariants = JSON.stringify(data.variants);
  card.dataset.productOptions = JSON.stringify(data.options);
  
  // Set initial price
  const firstAvailableVariant = data.variants.find(v => v.available) || data.variants[0];
  if (firstAvailableVariant) {
    updatePrice(card, firstAvailableVariant.id);
  }
  
  const hasColor = data.options?.some(o => /colou?r/i.test(o.name));
  const hasSize = data.options?.some(o => !/colou?r/i.test(o.name));
  const inner = document.createElement('div');
  inner.className = 'pdp-selectors-inner';
  
  // Get existing color container
  const colorContainer = dom.$('.pdp-complete-bottom .select-wrapper', card);
  
  if (hasColor) {
    const section = document.createElement('div');
    section.className = 'pdp-color-selector';
    
    if (colorContainer) {
      const clonedColorContainer = colorContainer.cloneNode(true);
      section.appendChild(clonedColorContainer);
      
      const dropdown = dom.$('.js-color-dropdown', clonedColorContainer);
      if (dropdown) {
        dropdown.remove();
        clonedColorContainer.insertAdjacentElement("afterend", dropdown);
        const trigger = clonedColorContainer; 
        const movedDropdown = dropdown; 

        if (!trigger.dataset.scrollBound) {
          trigger.dataset.scrollBound = "true";

          trigger.addEventListener("click", () => {
            setTimeout(() => {
              if (
                movedDropdown.style.display === "block" ||
                getComputedStyle(movedDropdown).display === "block"
              ) {
                smartScrollIntoViewInDrawer(movedDropdown);
              }
            }, 0);
          });
        }
      }
    } else {
      const colorVal = data.options.find(o => /colou?r/i.test(o.name))?.values[0];
      section.innerHTML = `<div class="color-info">Color: ${colorVal}</div>`;
    }
    
    inner.appendChild(section);
    setTimeout(() => initColorWatcher(card), 0);
  }
  
  data.options.forEach(option => {

      const optionName = option.name.toLowerCase();

      // COLOR
      if (/colou?r/.test(optionName)) {
        // Already handled separately (swatches)
        return;
      }

      // SIZE
      if (optionName === "size") {
        const section = document.createElement("div");
        section.className = "pdp-size-selector";
        createSizeDropdown(data, section, card);
        inner.appendChild(section);
        return;
      }

      // ANY OTHER OPTION → GENERIC DROPDOWN
      const section = document.createElement("div");
      section.className = "pdp-generic-selector";
      createGenericDropdown(option, data, section, card);
      inner.appendChild(section);
  });


    function createGenericDropdown(option, data, container, card) {

  /* ---------- Wrapper (SAME AS SIZE) ---------- */
  container.classList.add("pdp-size-selector");

  /* ---------- Hidden SELECT (SAME) ---------- */
  const select = document.createElement("select");
  select.className = "pdp-size-dropdown-select";
  select.dataset.optionName = option.name;

  const placeholder = document.createElement("option");
  placeholder.value = "";
  placeholder.textContent = `Select ${option.name}`;
  placeholder.disabled = true;
  select.appendChild(placeholder);

  option.values.forEach(v => {
    const opt = document.createElement("option");
    opt.value = v;
    opt.textContent = v;
    select.appendChild(opt);
  });

  select.addEventListener("change", () => {
    handleSelectChange(card);
    const span = container.querySelector(".js-selected-generic");
    if (span) span.textContent = select.value;
  });

  container.appendChild(select);

  /* ---------- Trigger (EXACT COPY) ---------- */
  const trigger = document.createElement("div");
  trigger.className = "select-wrapper select-btn js-size-trigger js-generic-trigger";
  trigger.innerHTML = `
    <span class="js-selected-generic">Select ${option.name}</span>
    <svg class="pdr-icon" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 14 8" fill="none">
      <path style="fill: transparent;" d="M1.06066 1.06067L7.0986 7.06067L13.1365 1.06067" stroke="#1E1E1E" stroke-width="1.5" stroke-miterlimit="16" stroke-linecap="square"/>
    </svg>
  `;
  container.appendChild(trigger);

  /* ---------- Dropdown (EXACT COPY) ---------- */
  const dropdown = document.createElement("div");
  dropdown.className = "color-dropdown js-size-dropdown js-generic-dropdown";
  dropdown.style.display = "none";

  option.values.forEach(v => {
    const opt = document.createElement("div");
    opt.className = "color-option";
    opt.dataset.genericValue = v;
    opt.textContent = v;

    opt.addEventListener("click", e => {
      e.stopPropagation();
      select.value = v;
      select.dispatchEvent(new Event("change", { bubbles: true }));
      trigger.querySelector(".js-selected-generic").textContent = v;
      dropdown.style.display = "none";
    });

    dropdown.appendChild(opt);
  });

  container.appendChild(dropdown);

  /* ---------- Toggle (EXACT COPY) ---------- */
  trigger.addEventListener("click", () => {
    dropdown.style.display =
      dropdown.style.display === "block" ? "none" : "block";
  });
}
  
  const btn = document.createElement('button');
  btn.className = 'pdp-add-to-cart-btn';
  btn.textContent = 'ADD';
  btn.dataset.productHandle = card.dataset.handle;
  btn.disabled = data.variants.length !== 1 || data.options.length !== 0;
  if (!btn.disabled) btn.dataset.variantId = data.variants[0].id;
  
  const btnSection = document.createElement('div');
  btnSection.className = 'pdp-button-section';
  btnSection.appendChild(btn);
  inner.appendChild(btnSection);
  
  const container = document.createElement('div');
  container.className = 'pdp-selectors-container';
  container.appendChild(inner);
  bottom.appendChild(container);
  setTimeout(() => {
    observeColorDropdowns();
  }, 0);
  
  if (hasSize) updateSizeState(card);
  else if (hasColor && !hasSize) updateColorOnly(card);
  else if (!hasColor && hasSize) updateSizeOnly(card);
  
  handleSelectChange(card);
}

function createSizeDropdown(data, container, card) {
  const sizeOpt = data.options.find(o => !/colou?r/i.test(o.name));
  if (!sizeOpt) return;

  const select = document.createElement('select');
  select.className = 'pdp-size-dropdown-select';
  select.dataset.optionName = sizeOpt.name;

  const placeholder = document.createElement('option');
  placeholder.value = '';
  placeholder.textContent = 'Select size';
  placeholder.disabled = true;
  select.appendChild(placeholder);

  sizeOpt.values.forEach(v => {
    const option = document.createElement('option');
    option.value = v;
    option.textContent = v;
    select.appendChild(option);
  });

  select.addEventListener('change', () => {
    handleSelectChange(card);
    updateSizeState(card);
    const selectedSizeSpan = dom.$('.js-selected-size', card);
    if (selectedSizeSpan) {
      selectedSizeSpan.textContent = select.value;
    }
  });

  container.appendChild(select);

  /* ---------- trigger ---------- */
  const trigger = document.createElement('div');
  trigger.className = 'select-wrapper select-btn js-size-trigger';
  trigger.innerHTML = `
    <span class="js-selected-size">Select size</span>
    <svg class="pdr-icon" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 14 8" fill="none">
      <path style="fill: transparent;" d="M1.06066 1.06067L7.0986 7.06067L13.1365 1.06067" stroke="#1E1E1E" stroke-width="1.5" stroke-miterlimit="16" stroke-linecap="square"/>
    </svg>
  `;

  container.appendChild(trigger);

  /* ---------- dropdown (SIBLING) ---------- */
  const dropdown = document.createElement('div');
  dropdown.className = 'color-dropdown js-size-dropdown manuly';
  dropdown.style.display = 'none';

  sizeOpt.values.forEach(v => {
    const opt = document.createElement('div');
    opt.className = 'color-option';
    
    // Initially set as available, will be updated by updateSizeState
    opt.dataset.sizeValue = v;
    opt.textContent = v;

    opt.addEventListener('click', e => {
      e.stopPropagation();
      if (opt.classList.contains('disabled')) return;

      select.value = v;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      trigger.querySelector('.js-selected-size').textContent = v;
      dropdown.style.display = 'none';
    });

    dropdown.appendChild(opt);
  });

  /* attach dropdown AFTER trigger */
  trigger.insertAdjacentElement('afterend', dropdown);

  /* ---------- toggle logic ---------- */
  trigger.addEventListener('click', e => {
    e.stopPropagation();
    const willOpen = dropdown.style.display !== "block";
    dropdown.style.display = willOpen ? "block" : "none";

    if (willOpen) scrollCartToBottom();
  });

  document.addEventListener('click', e => {
    if (!trigger.contains(e.target) && !dropdown.contains(e.target)) {
      dropdown.style.display = 'none';
    }
  });

  /* ---------- default selection ---------- */
  const firstAvail = sizeOpt.values.find(v =>
    data.variants.some(vr => vr.available && vr.options.includes(v))
  );

  if (firstAvail) {
    select.value = firstAvail;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    trigger.querySelector('.js-selected-size').textContent = firstAvail;
  }
}

// Also update the updateSizeState function to show/hide the sold out badge
function updateSizeState(card, currentSize) {
  const select = dom.$('.pdp-size-dropdown-select', card);
  if (!select) return;
  const variants = dom.parseJSON(card.dataset.productVariants, []);
  const color = card.dataset.selectedColor;
  
  [...select.options].forEach(o => {
    if (o.value) {
      o.disabled = false;
      o.style.opacity = '1';
      o.classList.remove('unavailable-option');
      o.removeAttribute('title');
    }
  });
  
  if (color?.trim()) {
    [...select.options].forEach(o => {
      if (!o.value) return;
      const v = product.findVariant(variants, color, o.value);
      const avail = v?.available !== false && (v?.inventory_quantity ?? 1) > 0;
      if (!avail) {
        o.disabled = true;
        o.style.opacity = '0.4';
        o.classList.add('unavailable-option');
        o.title = 'Out of stock for selected color';
      }
    });
  }
  
  if (currentSize) {
    const sizeText = dom.$('.js-selected-size', card);
    if (sizeText) sizeText.textContent = currentSize;
  }
  
  // Update dropdown options with sold out badges
  card.querySelectorAll('.js-size-dropdown .color-option').forEach(opt => {
    const isDisabled = [...select.options].find(o => o.value === opt.dataset.sizeValue)?.disabled;
    opt.classList.toggle('disabled', isDisabled);
    
    // Show/hide sold out badge based on disabled state
    const badge = opt.querySelector('.sold-out-badge');
    if (badge) {
      badge.style.display = isDisabled ? 'block' : 'none';
    }
  });
}

function initColorWatcher(card) {
  const span = dom.$('.js-selected-color', card);
  if (!span) return;
  const update = () => {
    const color = (dom.$('.color-name-text', span) || span).textContent.trim();
    if (color && color !== card.dataset.selectedColor) {
      card.dataset.selectedColor = color;
      handleSelectChange(card);
      updateSizeState(card);
    }
  };
  new MutationObserver(update).observe(span, { characterData: true, childList: true, subtree: true });
  card.querySelectorAll('.color-option').forEach(opt => opt.addEventListener('click', () => setTimeout(update, 10)));
  const initColor = (dom.$('.color-name-text', span) || span).textContent.trim();
  if (initColor) card.dataset.selectedColor = initColor;
  else (dom.$('.color-name-text', span) || span).textContent = 'Select';
  handleSelectChange(card);
}



function handleSelectChange(card, currentSize) {
  const btn = dom.$('.pdp-add-to-cart-btn', card);
  if (!btn) return;

  const variants = dom.parseJSON(card.dataset.productVariants, []);
  const options = dom.parseJSON(card.dataset.productOptions, []);

  if (!variants.length || !options.length) return;

  // -----------------------
  // 1) Read SELECTED VALUES
  // -----------------------

  let selectedValues = [];

  options.forEach((opt, idx) => {
    let val = '';
    // COLOR → from dataset
    if (/colou?r/i.test(opt.name)) {
      val = (card.dataset.selectedColor || '').trim();
    }

    // SIZE → from .pdp-size-dropdown-select
    else if (/size/i.test(opt.name)) {
      const sizeSelect = dom.$('.pdp-size-dropdown-select', card);
      val = currentSize || sizeSelect?.value || '';
    }

    // OTHER OPTION → from dropdown we generated
    else {
      console.log('other');
      const dropdown = dom.$(
        `.pdp-size-dropdown-select[data-option-name="${opt.name}"]`,
        card
      );
      val = dropdown?.value?.trim() || '';
    }

    selectedValues[idx] = val;
  });

  // If ANY empty → disable and exit
  if (selectedValues.some(v => !v || v === '')) {
    btn.disabled = true;
    btn.dataset.variantId = '';
    return;
  }

  // -----------------------
  // 2) Find matching variant
  // -----------------------

  let matchVariant = variants.find(v => {
    return selectedValues.every((sel, i) => {
      let opt = v[`option${i + 1}`];
      return opt && opt.trim().toLowerCase() === sel.toLowerCase();
    });
  });

  if (!matchVariant) {
    btn.disabled = true;
    btn.dataset.variantId = '';
    return;
  }

  btn.dataset.variantId = matchVariant.id;
  btn.disabled = !matchVariant.available;

  // -----------------------
  // 3) Update PRICE + IMAGE
  // -----------------------
  updatePrice(card, matchVariant.id);
  updateImages(card);

  // if (matchVariant.featured_image) {
  //   updateImage(card, matchVariant.featured_image);
  // }
}


function updateColorOnly(card) {
  const btn = dom.$('.pdp-add-to-cart-btn', card);
  if (!btn) return;
  const variants = dom.parseJSON(card.dataset.productVariants, []);
  const color = card.dataset.selectedColor;
  if (color?.trim()) {
    const v = variants.find(v => [v.option1, v.option2, v.option3].includes(color));
    btn.disabled = !v?.available;
    btn.dataset.variantId = v?.available ? v.id : '';
    
    // Update price when variant is selected
    if (v?.available && v.id) {
      updatePrice(card, v.id);
    }
  } else {
    btn.disabled = true;
    btn.dataset.variantId = '';
  }
}

function updateSizeOnly(card) {
  const btn = dom.$('.pdp-add-to-cart-btn', card);
  if (!btn) return;
  const select = dom.$('.pdp-size-dropdown-select', card);
  const variants = dom.parseJSON(card.dataset.productVariants, []);
  const size = select?.value;
  if (size?.trim()) {
    const v = variants.find(v => [v.option1, v.option2, v.option3].includes(size));
    btn.disabled = !v?.available;
    btn.dataset.variantId = v?.available ? v.id : '';
    
    // Update price when variant is selected
    if (v?.available && v.id) {
      updatePrice(card, v.id);
    }
  } else {
    btn.disabled = true;
    btn.dataset.variantId = '';
  }
}

function updateSizeState(card, currentSize) {
  const select = dom.$('.pdp-size-dropdown-select', card);
  if (!select) return;
  const variants = dom.parseJSON(card.dataset.productVariants, []);
  const color = card.dataset.selectedColor;
  [...select.options].forEach(o => {
    if (o.value) {
      o.disabled = false;
      o.style.opacity = '1';
      o.classList.remove('unavailable-option');
      o.removeAttribute('title');
    }
  });
  if (color?.trim()) {
    [...select.options].forEach(o => {
      if (!o.value) return;
      const v = product.findVariant(variants, color, o.value);
      const avail = v?.available !== false && (v?.inventory_quantity ?? 1) > 0;
      if (!avail) {
        o.disabled = true;
        o.style.opacity = '0.4';
        o.classList.add('unavailable-option');
        o.title = 'Out of stock for selected color';
      }
    });
  }
  if (currentSize) {
    const sizeText = dom.$('.js-selected-size', card);
    if (sizeText) sizeText.textContent = currentSize;
  }
  card.querySelectorAll('.js-size-dropdown.manuly .color-option').forEach(opt => {
    opt.classList.toggle('disabled', [...select.options].find(o => o.value === opt.dataset.sizeValue)?.disabled);
  });
}

function updateColorDropdown(card, currentColor) {
  const select = dom.$('.js-selected-color', card);
  const sizeDropdown = dom.$('.js-size-dropdown', card);
  if (!select) return;
  const swatchElem = dom.$('.color-swatch-inline', select);
  const swatchText = dom.$('.color-name-text', select) || select;
  const colorSwatchData = swatches.load()[currentColor] || {};
  let bg;
  if (colorSwatchData.colorImage) {
    bg = `url("${colorSwatchData.colorImage}")`;
  } else if (colorSwatchData.color) {
    bg = colorSwatchData.color;
  } else {
    bg = currentColor;
  }
  if (swatchElem) {
    swatchElem.style.setProperty('background', bg, 'important');
    swatchElem.dataset.color = currentColor;
  }
  if (swatchText) swatchText.textContent = currentColor;
  card.dataset.selectedColor = currentColor;
  if (sizeDropdown) sizeDropdown.style.display = 'none';
  setTimeout(() => {
    if (window.swatches && typeof window.swatches.apply === 'function') swatches.apply();
  }, 100);
}
 function updateImages(card, selectedColor) {
  if (!card) return;

  // 1) Get selected variant ID
  const variantId =
    card.dataset.selectedVariantId ||
    card.querySelector('[data-variant-id]')?.dataset.variantId ||
    card.querySelector('input[name="id"]')?.value;

  if (!variantId) return;

  // 2) Read script JSON (contains variant → images mapping)
  const scriptTag = dom.$(
    `script[data-id="productVariantsPatternThemeMetafields${card.dataset.handle}"]`,
    card
  );

  const variantImageData = dom.parseJSON(scriptTag?.textContent || "{}", {});

  // 3) Get images for selected variant
  const vImg = variantImageData[variantId];
  if (!vImg || !vImg.first_image) return;

  const primaryImage = vImg.first_image;
  const secondaryImage = vImg.second_image || vImg.first_image;

  // 4) Update card images
  const container = dom.$(".product__card-image", card);
  if (!container) return;

  const updatePicture = (picture, src) => {
    if (!picture || !src) return;

    const base = src.split("?")[0];

    picture.querySelectorAll("source").forEach((s) => {
      s.srcset = ["80", "160"]
        .map((sz) => `${base}?width=${sz} ${sz === "80" ? "1x" : "2x"}`)
        .join(", ");
    });

    const img = picture.querySelector("img");
    if (img) {
      img.src = `${base}?width=100`;
      img.srcset = ["80", "160"]
        .map((sz) => `${base}?width=${sz} ${sz === "80" ? "1x" : "2x"}`)
        .join(", ");
    }
  };

  const firstPicture = container.querySelector("picture:first-of-type");
  const secondPicture = container.querySelector("picture:nth-of-type(2)");

  updatePicture(firstPicture, primaryImage);
  updatePicture(secondPicture, secondaryImage);
}


function setupImages(card, data) {
  if (!card || !data) return;
  const imgMap = data.variants.reduce((a, v) => {
    if (v.featured_image?.src) {
      const color = v.option2 || v.option1;
      if (color) a[color] = {
        main: v.featured_image.src,
        secondary: getSecondary(v.id, card)
      };
    }
    return a;
  }, {});
  card.dataset.variantImages = JSON.stringify(imgMap);
  const productData = dom.parseJSON(card.dataset.productVariants, []);
  card.querySelectorAll('.color-option, input[name^="color-radio"]').forEach(opt => {
    if (!opt) return;
    opt.addEventListener('click', e => {
      e.stopPropagation();
      const currentSize = opt.dataset.sizeValue || dom.$('.pdp-size-dropdown-select', card)?.value;
      const currentColor = card.dataset.selectedColor;
      const isAvailableColor = productData.find(v => v.available && v.option1 === currentSize)?.option2 || null;
      const isCurrentColorAvailable = productData.some(v => v.available && v.option1 === currentSize && v.option2 === currentColor);
      const firstAvailableColor = isCurrentColorAvailable ? currentColor : isAvailableColor;
      if (!firstAvailableColor) return;
      updateColorDropdown(card, firstAvailableColor);
      setTimeout(() => {
        updateImages(card, firstAvailableColor);
        updateActiveSwatch(card, opt);
        updateSizeState(card, currentSize);
        handleSelectChange(card, currentSize);
      }, 50);
    });
  });
  const colorSpan = dom.$('.js-selected-color', card);
  if (colorSpan) {
    new MutationObserver(mutations => {
      mutations.forEach(() => {
        const colorElement = dom.$('.color-name-text', colorSpan) || colorSpan;
        if (colorElement) {
          const color = colorElement.textContent.trim();
          if (color && color !== 'Select') setTimeout(() => updateImages(card, color), 50);
        }
      });
    }).observe(colorSpan, { characterData: true, childList: true, subtree: true });
  }
  setTimeout(() => {
    const initialColor = card.dataset.selectedColor;
    if (initialColor) updateImages(card, initialColor);
    const sizeOpt = dom.$('.pdp-size-selector option:checked, .pdp-size-selector [aria-selected="true"], .pdp-size-selector .selected', card);
    if (sizeOpt) updateActiveSwatch(card, sizeOpt);
  }, 100);
}

function updateActiveSwatch(card, selectedOption) {
  const variants = dom.parseJSON(card.dataset.productVariants, []);
  const size = selectedOption.dataset?.sizeValue || dom.$('.pdp-size-dropdown-select', card)?.value;
  if (!size) return;
  const handle = card.dataset.handle;
  const sizeVariants = variants.filter(v => v.option1 === size);
  card.querySelectorAll(`input[name="color-radio-${handle}"]`).forEach(sw => {
    const match = sizeVariants.find(v => v.option2 === sw.dataset.color);
    const avail = match?.available;
    [sw, sw.closest('.outer-wrapper')].forEach(el => el?.classList.toggle('out-of-stock', !avail));
    sw.disabled = !avail;
  });
}

function getSecondary(vId, card) {
  const handle = card?.dataset?.handle;
  const script = handle
    ? dom.$(`script[data-id="productVariantsPatternThemeMetafields${handle}"]`, card)
    : null;
  return script ? dom.parseJSON(script.textContent, {})[vId]?.second_image : null;
}

document.addEventListener('click', async e => {
  const btn = e.target.closest('.pdp-add-to-cart-btn');
  if (!btn || btn.disabled || !btn.dataset.variantId) return;
  const loader = btn.querySelector('.btn-loader') || (() => {
    const el = document.createElement('span');
    el.className = 'btn-loader';
    btn.appendChild(el);
    return el;
  })();
  btn.disabled = true;
  btn.classList.add('loading');
  btn.dataset.originalText = btn.textContent.trim();
  if (btn.firstChild) btn.firstChild.textContent = '';
  loader.style.display = 'inline-block';
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: +btn.dataset.variantId, quantity: 1 }] })
    });
    if (res.ok) {
      await res.json();
      await cart.refresh();
      cart.open();
    }
  } catch (e) {
    console.error(e);
  } finally {
    loader.style.display = 'none';
    if (btn.firstChild) btn.firstChild.textContent = btn.dataset.originalText || 'ADD';
    btn.classList.remove('loading');
    btn.disabled = false;
  }
});

const debouncedSetup = ui.debounce(setupColorSwatchClickHandler, 100);
['turbo:load', 'turbolinks:load', 'cart:updated', 'cart:refresh'].forEach(e => document.addEventListener(e, debouncedSetup));

const debouncedInit = ui.debounce(init, 100);
['turbo:load', 'turbolinks:load', 'DOMContentLoaded', 'cart:updated', 'cart:refresh'].forEach(e => document.addEventListener(e, debouncedInit));

document.addEventListener('shopify:section:load', e => {
  if (e.target.querySelector('product-card[data-handle]')) setTimeout(init, 100);
});

new MutationObserver(m => m.forEach(mu => {
  if ([...mu.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('product-card[data-handle]') || n.querySelector?.('product-card[data-handle]')))) setTimeout(init, 50);
})).observe(document.body, { childList: true, subtree: true });

['touchstart', 'touchmove', 'mousedown', 'mousemove'].forEach(e => document.addEventListener(e, e => {
  if (e.target.closest('.pdp-selectors-container')) e.stopPropagation();
}, { passive: true }));

window.applyColorSwatches = swatches.apply.bind(swatches);

function setupColorSwatchClickHandler() {
  document.addEventListener('click', e => {
    const colorOption = e.target.closest('.color-option[data-color-value]') || e.target.closest('.inner-wrapper');
    if (!colorOption) return;
    const card = colorOption.closest('product-card[data-handle]');
    if (!card) return;
    let selectedColor;
    let selectedColorName;
    if (colorOption.classList.contains('color-option')) {
      selectedColor = colorOption.dataset.colorValue;
      selectedColorName = colorOption.dataset.colorName || selectedColor;
      const selectedColorSpan = dom.$('.js-selected-color', card);
      if (selectedColorSpan) {
        const colorNameSpan = dom.$('.color-name-text', selectedColorSpan) || selectedColorSpan;
        colorNameSpan.textContent = selectedColorName;
        const swatch = dom.$('.color-swatch-inline', selectedColorSpan);
        const clickedSwatch = dom.$('.color-swatch-inline', colorOption);
        if (swatch && clickedSwatch) swatch.style.background = clickedSwatch.style.background;
      }
    } else {
      const colorInput = colorOption.querySelector('input[type="radio"][name^="color-radio"]');
      if (!colorInput) return;
      selectedColor = colorInput.value;
      selectedColorName = colorInput.dataset.colorName || selectedColor;
    }
    card.dataset.selectedColor = selectedColorName;
    card.dataset.lastChanged = 'color';
    const variants = dom.parseJSON(card.dataset.productVariants || '[]');
    const availableSizes = variants.filter(v => {
      const hasColor = [v.option1, v.option2, v.option3].some(opt => opt?.toLowerCase() === selectedColorName?.toLowerCase());
      return hasColor && v.available === true;
    }).map(v => {
      return [v.option1, v.option2, v.option3].find(opt => opt?.toLowerCase() !== selectedColorName?.toLowerCase());
    }).filter(Boolean);
    const sizeSelect = dom.$('.pdp-size-dropdown-select', card);
    const sizeTrigger = dom.$('.js-size-trigger', card);
    const sizeDropdown = dom.$('.js-size-dropdown', sizeTrigger);
    if (sizeSelect && sizeTrigger) {
      const sizeOptions = [...sizeSelect.options].filter(opt => opt.value);
      sizeOptions.forEach(opt => {
        const isAvailable = availableSizes.some(size => size.toLowerCase() === opt.value.toLowerCase());
        opt.disabled = !isAvailable;
        opt.style.opacity = isAvailable ? '1' : '0.4';
        opt.classList.toggle('unavailable-option', !isAvailable);
        opt.title = isAvailable ? '' : 'Out of stock for selected color';
      });
      const dropdownOptions = dom.$$('.js-size-dropdown .color-option', card);
      dropdownOptions.forEach(opt => {
        const isAvailable = availableSizes.some(size => size.toLowerCase() === opt.dataset.sizeValue?.toLowerCase());
        opt.classList.toggle('disabled', !isAvailable);
      });
      if (availableSizes.length > 0) {
        const firstAvailableSize = availableSizes[0];
        sizeSelect.value = firstAvailableSize;
        const selectedSizeSpan = dom.$('.js-selected-size', sizeTrigger);
        if (selectedSizeSpan) selectedSizeSpan.textContent = firstAvailableSize;
        sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        if (sizeDropdown) sizeDropdown.style.display = 'none';
      } else {
        sizeSelect.value = '';
        const selectedSizeSpan = dom.$('.js-selected-size', sizeTrigger);
        if (selectedSizeSpan) selectedSizeSpan.textContent = 'Select size';
      }
    }
    updateImages(card);
    handleSelectChange(card);
  });
  // document.addEventListener("click", function (e) {
  //   const trigger = e.target.closest(
  //     ".js-selected-color, .pdp-color-selector .select-wrapper",
  //   );
  //   if (!trigger) return;

  //   const card = trigger.closest("product-card");
  //   if (!card) return;

  //   const dropdown = card.querySelector(".js-color-dropdown");
  //   if (!dropdown) return;

  //   const willOpen =
  //     dropdown.style.display !== "block" &&
  //     getComputedStyle(dropdown).display !== "block";

  //   if (willOpen) {
  //     setTimeout(scrollCartToBottom, 120);
  //   }
  // });
}
function observeColorDropdowns() {
  document.querySelectorAll(".js-color-dropdown").forEach((dropdown) => {
    if (dropdown.dataset.scrollObserverAttached) return;

    dropdown.dataset.scrollObserverAttached = "true";

    const observer = new MutationObserver(() => {
      const isVisible =
        dropdown.style.display === "block" ||
        getComputedStyle(dropdown).display === "block";

      if (isVisible) {
        scrollCartToBottom();
      }
    });

    observer.observe(dropdown, {
      attributes: true,
      attributeFilter: ["style", "class"],
    });
  });
}
function initializeColorSwatches() {
  document.querySelectorAll('color-picker input[type="radio"][name^="color-radio"]').forEach(input => {
    input.removeAttribute('disabled');
    const wrapper = input.closest('.outer-wrapper');
    if (wrapper) wrapper.classList.remove('out-of-stock');
  });
  document.querySelectorAll('.js-color-dropdown .color-option').forEach(option => {
    option.classList.remove('disabled');
  });
  updateActiveColorState();
}

function updateActiveColorState() {
  document.querySelectorAll('color-picker').forEach(picker => {
    const checkedInput = picker.querySelector('input[type="radio"]:checked');
    if (checkedInput) {
      picker.querySelectorAll('.outer-wrapper').forEach(wrapper => {
        wrapper.classList.remove('active');
      });
      const activeWrapper = checkedInput.closest('.outer-wrapper');
      if (activeWrapper) activeWrapper.classList.add('active');
    }
  });
}

function updatePrice(card, variantId) {
  const priceContainer = dom.$('.pdp-complete-price', card);
  if (!priceContainer) return;
  
  const variants = dom.parseJSON(card.dataset.productVariants, []);
  const selectedVariant = variants.find(v => v.id === variantId);
  
  if (!selectedVariant) return;

  // Sweepstakes entries are priced off the variant too — keep the pill in step.
  window.SweepsEntries?.sync(card, selectedVariant.price);
  
  const priceSpan = dom.$('.sale', priceContainer);
  if (!priceSpan) return;
  
  // Format price (assuming price is in cents)
  const price = selectedVariant.price / 100;
  priceSpan.textContent = `$${price}`;
  priceSpan.dataset.selectedPrice = selectedVariant.price;
  
  // Handle compare at price if exists
  if (selectedVariant.compare_at_price > selectedVariant.price) {
    if (!priceSpan.nextElementSibling?.classList.contains('compare-at')) {
      const compareSpan = document.createElement('span');
      compareSpan.className = 'compare-at';
      compareSpan.textContent = `$${selectedVariant.compare_at_price / 100}`;
      priceSpan.insertAdjacentElement('afterend', compareSpan);
    } else {
      priceSpan.nextElementSibling.textContent = `$${selectedVariant.compare_at_price / 100}`;
    }
  } else {
    // Remove compare at price if exists
    const compareSpan = priceSpan.nextElementSibling;
    if (compareSpan?.classList.contains('compare-at')) {
      compareSpan.remove();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  swatches.apply();
  setupColorSwatchClickHandler();
  initializeColorSwatches();
  new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length) {
        initializeColorSwatches();
      }
    });
    swatches.apply();
  }).observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('click', e => {
  const colorInput = e.target.closest('input[type="radio"][name^="color-radio"]');
  if (colorInput) {
    setTimeout(updateActiveColorState, 10);
  }
});

document.addEventListener("click", function (e) {
  const wrapper = e.target.closest(".js-color-dropdown .inner-wrapper");
  if (!wrapper) return;

  const radio = wrapper.querySelector('input[type="radio"]');
  if (!radio || radio.disabled) return;

  radio.click();
});

function checkAllCardBottoms() {
  const cards = document.querySelectorAll('.pdp-complete-card');
  
  cards.forEach(card => {
    const cardBottom = card.querySelector('.pdp-card-bottom');
    const loader = card.querySelector('.dot-loader');
    
    if (!cardBottom || !loader) return;
    
    if (cardBottom.children.length > 0) {
      cardBottom.style.display = 'block';
      loader.style.display = 'none';
    } else {
      cardBottom.style.display = 'none';
      loader.style.display = 'flex';
    }
  });
}

// Initial check
checkAllCardBottoms();

// More efficient: Observe only the cards container if you know it
const cardsContainer = document.querySelector('.cards-container'); // Replace with your actual container selector
if (cardsContainer) {
  const observer = new MutationObserver(checkAllCardBottoms);
  observer.observe(cardsContainer, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });
} else {
  // Fallback to observing body with specific filter
  const observer = new MutationObserver((mutations) => {
    let shouldCheck = false;
    
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
        shouldCheck = true;
        break;
      }
      if (mutation.target.classList && 
          mutation.target.classList.contains('pdp-card-bottom')) {
        shouldCheck = true;
        break;
      }
    }
    
    if (shouldCheck) {
      checkAllCardBottoms();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });
}

// Multiple checks for different loading scenarios
['DOMContentLoaded', 'load'].forEach(event => {
  window.addEventListener(event, checkAllCardBottoms);
});

// Periodic checks for dynamically loaded content (optional)
let checkCount = 0;
const interval = setInterval(() => {
  checkAllCardBottoms();
  checkCount++;
  
  // Stop after 5 seconds to prevent infinite checking
  if (checkCount >= 10) {
    clearInterval(interval);
  }
}, 500);


/////////////////////////////////////////////////////////////////

// (function() {
//   'use strict';
  
//   const processedContainers = new WeakSet();
  
//   function forceAddScrollbar(container) {
//     if (processedContainers.has(container) && container.querySelector('.custom-track')) {
//       return;
//     }
    
//     // Remove any existing track
//     const oldTrack = container.querySelector('.custom-track');
//     if (oldTrack) oldTrack.remove();
    
//     // SMART DETECTION: Find or create scrollable wrapper
//     let scrollContent = null;
//     let itemCount = 0;
    
//     // Check for color-picker (color dropdown)
//     if (container.querySelector('color-picker')) {
//       scrollContent = container.querySelector('color-picker');
//       // Count labels inside color-picker
//       itemCount = scrollContent.querySelectorAll('label').length;
//     }
//     // Check for js-size-scroll
//     else if (container.querySelector('.js-size-scroll')) {
//       scrollContent = container.querySelector('.js-size-scroll');
//       itemCount = scrollContent.children.length;
//     }
//     // For size dropdown with direct .color-option children
//     else if (container.querySelector('.color-option') && !container.querySelector('.custom-scroll-content')) {
//       // Count options
//       const options = Array.from(container.children).filter(child => 
//         child.classList && child.classList.contains('color-option')
//       );
//       itemCount = options.length;
      
//       // Only create wrapper and scrollbar if more than 3 items
//       if (itemCount > 3) {
//         // Create a wrapper div for all options
//         const wrapper = document.createElement('div');
//         wrapper.className = 'custom-scroll-content';
        
//         // Move all direct .color-option children into wrapper
//         options.forEach(option => {
//           wrapper.appendChild(option);
//         });
        
//         // Insert wrapper as first child
//         container.insertBefore(wrapper, container.firstChild);
//         scrollContent = wrapper;
//       } else {
//         // Less than or equal to 3 items - set height to max-content
//         container.style.height = 'max-content';
//         container.style.maxHeight = 'max-content';
//         container.style.overflow = 'visible';
//         processedContainers.add(container);
//         return;
//       }
//     }
//     // Fallback to first child
//     else {
//       scrollContent = container.children[0];
//       // Try to count items
//       if (scrollContent) {
//         itemCount = scrollContent.children.length || scrollContent.querySelectorAll('*').length;
//       }
//     }
    
//     if (!scrollContent) return;
    
//     // Skip if the scrollContent is our track
//     if (scrollContent.classList && scrollContent.classList.contains('custom-track')) {
//       scrollContent = container.children[1] || container.children[0];
//     }
    
//     // Count items if not already counted
//     if (itemCount === 0) {
//       itemCount = scrollContent.children.length || scrollContent.querySelectorAll('label, .color-option, > div').length;
//     }
    
//     // Only apply custom scrollbar if more than 3 items
//     if (itemCount <= 3) {
//       container.style.height = 'max-content';
//       container.style.maxHeight = 'max-content';
//       container.style.overflow = 'visible';
//       scrollContent.style.overflow = 'visible';
//       scrollContent.style.height = 'auto';
//       scrollContent.style.maxHeight = 'max-content';
//       processedContainers.add(container);
//       return;
//     }
    
//     // Set fixed height for scrolling (more than 3 items)
//     container.style.height = '10rem';
//     container.style.maxHeight = '10rem';
//     container.style.overflow = 'hidden';
    
//     // Create track
//     const trackId = 'custom-track-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
//     const track = document.createElement('div');
//     track.id = trackId;
//     track.className = 'custom-track';
    
//     // Create thumb
//     const thumbId = 'custom-thumb-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
//     const thumb = document.createElement('div');
//     thumb.id = thumbId;
//     thumb.className = 'custom-thumb';
    
//     track.style.cssText = 'display:block!important;visibility:visible!important;opacity:1!important;background:#d1d5db!important;width:3px!important;position:absolute!important;right:4px!important;top:4px!important;bottom:4px!important;border-radius:4px!important;z-index:999999!important;pointer-events:all!important;';
//     thumb.style.cssText = 'display:block!important;visibility:visible!important;opacity:1!important;background:#000!important;width:100%!important;min-height:25px!important;position:absolute!important;top:0!important;left:0!important;border-radius:4px!important;cursor:grab!important;z-index:9999999!important;pointer-events:all!important;transform:translateY(0)!important;';
    
//     track.appendChild(thumb);
//     container.appendChild(track);
    
//     // Apply scroll styles to the scrollable content
//     scrollContent.style.overflowY = 'scroll';
//     scrollContent.style.height = '100%';
//     scrollContent.style.paddingRight = '12px';
//     scrollContent.style.scrollbarWidth = 'none';
//     scrollContent.style.msOverflowStyle = 'none';
    
//     // Update thumb position and size
//     function updateThumb() {
//       if (!track.isConnected) {
//         container.appendChild(track);
//       }
      
//       const scrollHeight = scrollContent.scrollHeight;
//       const clientHeight = scrollContent.clientHeight;
      
//       if (scrollHeight <= clientHeight) {
//         track.style.display = 'none';
//         return;
//       }
      
//       track.style.display = 'block';
      
//       const trackHeight = track.clientHeight;
//       const thumbHeight = Math.max(25, (clientHeight / scrollHeight) * trackHeight);
//       const maxScroll = scrollHeight - clientHeight;
//       const maxTop = trackHeight - thumbHeight;
//       const scrollPercent = scrollContent.scrollTop / (maxScroll || 1);
//       const topPosition = maxTop * scrollPercent;
      
//       thumb.style.height = thumbHeight + 'px';
//       thumb.style.transform = 'translateY(' + topPosition + 'px)';
//     }
    
//     // Update multiple times to catch rendering
//     setTimeout(updateThumb, 0);
//     setTimeout(updateThumb, 10);
//     setTimeout(updateThumb, 50);
//     setTimeout(updateThumb, 100);
//     setTimeout(updateThumb, 500);
    
//     // Event listeners
//     scrollContent.addEventListener('scroll', updateThumb);
    
//     // Dragging
//     let isDragging = false;
//     let startY, startScroll;
    
//     thumb.addEventListener('mousedown', function(e) {
//       isDragging = true;
//       startY = e.clientY;
//       startScroll = scrollContent.scrollTop;
//       thumb.style.background = '#333';
//       thumb.style.cursor = 'grabbing';
//       e.preventDefault();
//       e.stopPropagation();
//     });
    
//     document.addEventListener('mousemove', function(e) {
//       if (!isDragging) return;
      
//       const delta = e.clientY - startY;
//       const maxScroll = scrollContent.scrollHeight - scrollContent.clientHeight;
//       const maxThumbTravel = track.clientHeight - thumb.clientHeight;
      
//       if (maxThumbTravel > 0) {
//         const scrollDelta = (delta / maxThumbTravel) * maxScroll;
//         scrollContent.scrollTop = Math.max(0, Math.min(startScroll + scrollDelta, maxScroll));
//       }
//     });
    
//     document.addEventListener('mouseup', function() {
//       if (isDragging) {
//         isDragging = false;
//         thumb.style.background = '#000';
//         thumb.style.cursor = 'grab';
//       }
//     });
    
//     // Track click
//     track.addEventListener('click', function(e) {
//       if (e.target === track) {
//         const rect = track.getBoundingClientRect();
//         const clickPercent = (e.clientY - rect.top) / track.clientHeight;
//         const maxScroll = scrollContent.scrollHeight - scrollContent.clientHeight;
//         scrollContent.scrollTop = clickPercent * maxScroll;
//       }
//     });
    
//     // Observe size changes
//     if (window.ResizeObserver) {
//       const observer = new ResizeObserver(updateThumb);
//       observer.observe(scrollContent);
//       observer.observe(container);
//     }
    
//     // Store references
//     container._track = track;
//     container._thumb = thumb;
//     container._scrollContent = scrollContent;
    
//     processedContainers.add(container);
//   }
  
//   // Poll for containers
//   function pollForContainers() {
//     const containers = document.querySelectorAll('.custom-scroll');
    
//     for (let i = 0; i < containers.length; i++) {
//       const container = containers[i];
      
//       // Re-evaluate item count for existing containers
//       let itemCount = 0;
//       if (container.querySelector('color-picker')) {
//         itemCount = container.querySelector('color-picker').querySelectorAll('label').length;
//       } else if (container.querySelector('.custom-scroll-content')) {
//         itemCount = container.querySelector('.custom-scroll-content').children.length;
//       } else {
//         const options = Array.from(container.children).filter(child => 
//           child.classList && child.classList.contains('color-option')
//         );
//         itemCount = options.length;
//       }
      
//       // If items <= 3, ensure no scrollbar and max-content height
//       if (itemCount > 0 && itemCount <= 3) {
//         const track = container.querySelector('.custom-track');
//         if (track) track.remove();
//         container.style.setProperty('height', 'max-content', 'important');
//         container.style.setProperty('max-height', 'max-content', 'important');
//         container.style.overflow = 'visible';
//         const scrollContent = container.querySelector('.custom-scroll-content') || container.querySelector('color-picker') || container.children[0];
//         if (scrollContent) {
//           scrollContent.style.overflow = 'visible';
//           scrollContent.style.height = 'auto';
//           scrollContent.style.maxHeight = 'max-content';
//         }
//         continue;
//       }
      
//       // Handle containers with > 3 items
//       if (!container.querySelector('.custom-track')) {
//         forceAddScrollbar(container);
//       } else {
//         const track = container.querySelector('.custom-track');
//         if (track.style.display === 'none' || window.getComputedStyle(track).display === 'none') {
//           track.style.display = 'block';
//           track.style.visibility = 'visible';
//           track.style.opacity = '1';
//         }
//       }
//     }
//   }
  
//   // Start polling
//   setInterval(pollForContainers, 500);
  
//   // Initial run
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', pollForContainers);
//   } else {
//     pollForContainers();
//   }
  
//   // Watch for DOM changes
//   const domObserver = new MutationObserver(function() {
//     setTimeout(pollForContainers, 50);
//   });
  
//   domObserver.observe(document.body, {
//     childList: true,
//     subtree: true,
//     attributes: true,
//     attributeFilter: ['class', 'style']
//   });
  
//   // Shopify events
//   if (window.Shopify) {
//     document.addEventListener('shopify:section:load', function() {
//       setTimeout(pollForContainers, 100);
//     });
//   }
  
// })();

/////////////////////////////////////////////////////////////////

// (function () {
//   'use strict';

//   function setupHorizontalScroll(container) {
//     if (container.querySelector('.h-track')) return;

//     // Container setup
//     container.style.position = 'relative';
//     container.style.overflowX = 'auto';
//     container.style.overflowY = 'hidden';
//     container.style.whiteSpace = 'nowrap';
//     container.style.scrollbarWidth = 'none';
//     container.style.msOverflowStyle = 'none';
//     container.style.webkitOverflowScrolling = 'touch';

//     // Create elements
//     const track = document.createElement('div');
//     track.className = 'h-track';
//     track.style.willChange = 'width';

//     const thumb = document.createElement('div');
//     thumb.className = 'h-thumb';
//     thumb.style.willChange = 'transform, width';

//     track.appendChild(thumb);
//     container.appendChild(track);

//     const children = Array.from(container.children).filter(
//       (c) => !c.classList.contains('h-track')
//     );

//     if (children.length <= 3) {
//       track.style.display = 'none';
//       container.style.overflowX = 'visible';
//       return;
//     }

//     // Cache selectors
//     const thumbnails = container.querySelectorAll('.thumbnails__thumbnail, .thumbnail__square, [data-media-id]');
//     const gap = 5;
//     let rafId = null;
//     let totalWidth = 0;
//     let trackWidth = 0;
//     let thumbWidth = 0;

//     // Pre-calculate total width (only when needed)
//     function calculateTotalWidth() {
//       totalWidth = 0;
//       if (thumbnails.length > 0) {
//         for (let i = 0; i < thumbnails.length; i++) {
//           const thumb = thumbnails[i];
//           const style = window.getComputedStyle(thumb);
//           totalWidth += thumb.offsetWidth;
//           totalWidth += parseFloat(style.marginLeft) || 0;
//           totalWidth += parseFloat(style.marginRight) || 0;
//           if (i < thumbnails.length - 1) totalWidth += gap;
//         }
//       }
//       return totalWidth;
//     }

//     function updateThumb() {
//       if (rafId) return;
      
//       rafId = requestAnimationFrame(() => {
//         rafId = null;
        
//         // Batch read operations
//         const scrollWidth = container.scrollWidth;
//         const clientWidth = container.clientWidth;
//         const scrollLeft = container.scrollLeft;

//         if (scrollWidth <= clientWidth) {
//           track.style.display = 'none';
//           return;
//         }

//         track.style.display = 'block';
        
//         // Calculate track width
//         calculateTotalWidth();
//         track.style.width = totalWidth + 'px';
//         trackWidth = track.offsetWidth;
        
//         // Calculate thumb size
//         thumbWidth = Math.max(20, (clientWidth / scrollWidth) * trackWidth);
//         const displayThumbWidth = thumbWidth / 1.3;
//         const maxScroll = scrollWidth - clientWidth;
//         const maxLeft = trackWidth - displayThumbWidth;
//         const scrollPercent = scrollLeft / (maxScroll || 1);
//         const left = maxLeft * scrollPercent;

//         // Batch write operations
//         thumb.style.width = displayThumbWidth + 'px';
//         thumb.style.transform = `translate3d(${left}px, 0, 0)`;
//       });
//     }

//     // Debounced scroll handler
//     let ticking = false;
//     container.addEventListener('scroll', () => {
//       if (!ticking) {
//         requestAnimationFrame(() => {
//           updateThumb();
//           ticking = false;
//         });
//         ticking = true;
//       }
//     }, { passive: true });

//     // Dragging with RAF
//     let isDragging = false;
//     let startX, startScroll;

//     thumb.addEventListener('mousedown', function(e) {
//       isDragging = true;
//       startX = e.clientX;
//       startScroll = container.scrollLeft;
//       thumb.style.background = '#333';
//       thumb.style.cursor = 'grabbing';
//       container.style.scrollBehavior = 'auto';
//       e.preventDefault();
//       e.stopPropagation();
//     });

//     document.addEventListener('mousemove', function(e) {
//       if (!isDragging) return;
//       e.preventDefault();

//       requestAnimationFrame(() => {
//         const delta = e.clientX - startX;
//         const maxScroll = container.scrollWidth - container.clientWidth;
//         const maxThumbTravel = trackWidth - (thumbWidth / 1.3);

//         if (maxThumbTravel > 0) {
//           const scrollDelta = (delta / maxThumbTravel) * maxScroll;
//           container.scrollLeft = Math.max(0, Math.min(startScroll + scrollDelta, maxScroll));
//         }
//       });
//     }, { passive: false });

//     document.addEventListener('mouseup', function() {
//       if (isDragging) {
//         isDragging = false;
//         thumb.style.background = '#000';
//         thumb.style.cursor = 'grab';
//         container.style.scrollBehavior = 'smooth';
//       }
//     });

//     // Track click with smooth scroll
//     track.addEventListener('click', function(e) {
//       if (e.target !== track) return;
      
//       const rect = track.getBoundingClientRect();
//       const clickPercent = (e.clientX - rect.left) / trackWidth;
//       const maxScroll = container.scrollWidth - container.clientWidth;
      
//       container.style.scrollBehavior = 'smooth';
//       container.scrollTo({
//         left: clickPercent * maxScroll,
//         behavior: 'smooth'
//       });
//     });

//     // Mouse wheel with passive prevention
//     container.addEventListener('wheel', function(e) {
//       e.preventDefault();
//       container.scrollLeft += e.deltaY;
//     }, { passive: false });

//     // Initial updates with RAF
//     requestAnimationFrame(updateThumb);
//     setTimeout(() => requestAnimationFrame(updateThumb), 100);
//     setTimeout(() => requestAnimationFrame(updateThumb), 300);

//     // Resize observer with debounce
//     let resizeTimeout;
//     if (window.ResizeObserver) {
//       const observer = new ResizeObserver(() => {
//         clearTimeout(resizeTimeout);
//         resizeTimeout = setTimeout(() => {
//           requestAnimationFrame(updateThumb);
//         }, 16);
//       });
//       observer.observe(container);
      
//       if (thumbnails.length > 0) {
//         thumbnails.forEach(thumb => observer.observe(thumb));
//       }
//     }
//   }

//   function init() {
//     const containers = document.querySelectorAll('.custom-scroll-horizontal:not([data-h-scroll])');
//     for (let i = 0; i < containers.length; i++) {
//       containers[i].setAttribute('data-h-scroll', '1');
//       setupHorizontalScroll(containers[i]);
//     }
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   setInterval(function() {
//     const containers = document.querySelectorAll('.custom-scroll-horizontal:not([data-h-scroll])');
//     for (let i = 0; i < containers.length; i++) {
//       containers[i].setAttribute('data-h-scroll', '1');
//       setupHorizontalScroll(containers[i]);
//     }
//   }, 500);

//   if (window.Shopify) {
//     document.addEventListener('shopify:section:load', () => {
//       setTimeout(init, 100);
//     });
//   }

// })();

////////////////////////////////////////////////////////////////////
 
